export default 'Rejoignez le réseau SEF : artisans RGE, délégataires, obligés énergie. Mandat CEE, charte qualité officielle, modèle transparent. Candidature en 5 minutes.';
